<button class="btn btn-primary view-changelog-btn" (click)='onClick()'>
  View change log
</button>
